import {Separator} from 'platform/components';
import {Grid, GridItem, Hide, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';
import {ReadOnlyField} from '@dms/shared-aftersales';

import {TransferOrderReadOnlyFields} from '../types/TransferOrderReadOnlyFields';

interface BasicInformationReadOnlyProps {
  readOnlyFields: TransferOrderReadOnlyFields;
  shouldHideSentAndReceivedDetails?: boolean;
}

export function BasicInformationReadOnly(props: BasicInformationReadOnlyProps) {
  return (
    <VStack spacing={4}>
      <Grid columns={4}>
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.fromWarehouse')}
          value={props.readOnlyFields.sourceWarehouse}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.destinationBranch')}
          value={props.readOnlyFields.destinationBranch}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.destinationWarehouse')}
          value={props.readOnlyFields.destinationWarehouse}
        />
        <ReadOnlyField
          label={i18n.t('entity.warehouse.labels.destinationAuthorizationProfile')}
          value={props.readOnlyFields.destinationAuthorizationProfile}
        />
        <GridItem span={2}>
          <ReadOnlyField label={i18n.t('general.labels.note')} value={props.readOnlyFields.note} />
        </GridItem>
      </Grid>
      <Hide when={props.shouldHideSentAndReceivedDetails}>
        <Separator spacing={0} />
        <Grid columns={4}>
          <ReadOnlyField
            label={i18n.t('entity.warehouse.labels.sentBy')}
            value={props.readOnlyFields.sentBy}
          />
          <ReadOnlyField
            label={i18n.t('entity.warehouse.labels.sentAt')}
            value={props.readOnlyFields.sentAt}
          />
          <ReadOnlyField
            label={i18n.t('entity.warehouse.labels.receivedBy')}
            value={props.readOnlyFields.receivedBy}
          />
          <ReadOnlyField
            label={i18n.t('entity.warehouse.labels.receivedAt')}
            value={props.readOnlyFields.receivedAt}
          />
        </Grid>
      </Hide>
    </VStack>
  );
}
